/* blnc-switcher.js — toggle country/language dropdown */
(function() {
  'use strict';

  function initSwitcher() {
    var form = document.getElementById('blnc-country-switcher');
    if (!form) return;
    var toggle = form.querySelector('.blnc-country-switcher__toggle');
    var menu = form.querySelector('.blnc-country-switcher__menu');
    if (!toggle || !menu) return;

    function close() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    function open() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      if (menu.hidden) open(); else close();
    });

    document.addEventListener('click', function(e) {
      if (!form.contains(e.target)) close();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwitcher);
  } else {
    initSwitcher();
  }
})();
